export { default as LoadingArea } from './LoadingArea'
export * as LoadingAreaStyles from './LoadingArea.styles'
